import React from 'react';

function App() {
  const value = ' OIDC SPA with BFF patterns';
  return <div>Welcome to my test site for testing {value}.</div>;
}

export default App;
